import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { AthleteGLMContact, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

/**
 * Server-side email-filter search for linkable GLM contacts. Results are intentionally
 * NOT cached (staleTime: 0) so the modal always reflects current GLM state and
 * already-linked flags.
 *
 * Gated at >= 3 characters: GLM's contacts/search "contains" filter rejects shorter
 * values with a 422, so we don't fire the request until the minimum is met.
 */
export const GLM_CONTACT_SEARCH_MIN_CHARS = 3;
export default function useSearchGLMContacts(
  athleteId: string | null,
  email: string,
): UseQueryResult<AxiosResponse<AthleteGLMContact[]>, AxiosError<ErrorMessage>> {
  const trimmed = email.trim();
  return useQuery(
    ['glm-contact-search', athleteId, trimmed],
    () =>
      client.get<AthleteGLMContact[]>(
        `athletes/${athleteId}/glm/search-contacts/?email=${encodeURIComponent(trimmed)}`,
      ),
    {
      enabled: !!athleteId && trimmed.length >= GLM_CONTACT_SEARCH_MIN_CHARS,
      staleTime: 0,
      cacheTime: 0,
      keepPreviousData: true,
    },
  );
}
